module.exports = "<div class=\"content-top clearfix\">\n  <h1 class=\"al-title\" translate>{{ activePageTitle }}</h1>\n\n  <ul class=\"breadcrumb al-breadcrumb\">\n    <li class=\"breadcrumb-item\">\n      <a routerLink=\"/pages/dashboard/allDevices\" translate>{{'general.home'}}</a>\n    </li>\n    <li class=\"breadcrumb-item active\" translate>{{ activePageTitle }}</li>\n  </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baContentTop/baContentTop.html
// module id = ./src/app/theme/components/baContentTop/baContentTop.html
// module chunks = main